import { format, isToday, isTomorrow, isPast } from 'date-fns'

/** Reminder choices: minutes before the due time (null = none). */
export const REMINDERS = [
  { value: '', label: 'No reminder' },
  { value: 0, label: 'At the due time' },
  { value: 15, label: '15 minutes before' },
  { value: 60, label: '1 hour before' },
  { value: 1440, label: '1 day before' },
]

/** "2026-10-17T10:00:00" ⇄ the value of an <input type="datetime-local"> (minutes precision). */
export const toInputDateTime = (iso) => (iso ? iso.slice(0, 16) : '')
export const fromInputDateTime = (value) => (value ? `${value}:00` : null)

/** Tomorrow at 10:00, as an input value: the default due time of a new task. */
export const defaultDue = () => {
  const d = new Date()
  d.setDate(d.getDate() + 1)
  d.setHours(10, 0, 0, 0)
  return format(d, "yyyy-MM-dd'T'HH:mm")
}

/** Short, human due label: "Today 15:00", "Tomorrow 10:00", "17 Oct 10:00". */
export const dueLabel = (iso) => {
  if (!iso) return 'No due date'
  const d = new Date(iso)
  const time = format(d, 'HH:mm')
  if (isToday(d)) return `Today ${time}`
  if (isTomorrow(d)) return `Tomorrow ${time}`
  return format(d, d.getFullYear() === new Date().getFullYear() ? 'd MMM HH:mm' : 'd MMM yyyy HH:mm')
}

/** Open tasks grouped for the list: overdue, today, later, no date. Done tasks last. */
export const groupTasks = (tasks) => {
  const groups = { overdue: [], today: [], upcoming: [], undated: [], done: [] }
  tasks.forEach((t) => {
    if (t.status === 'DONE') groups.done.push(t)
    else if (!t.dueAt) groups.undated.push(t)
    else if (isPast(new Date(t.dueAt))) groups.overdue.push(t)
    else if (isToday(new Date(t.dueAt))) groups.today.push(t)
    else groups.upcoming.push(t)
  })
  return groups
}

export const GROUP_LABELS = { overdue: 'Overdue', today: 'Due today', upcoming: 'Upcoming', undated: 'No due date', done: 'Done' }
